import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import MobileMenu from '../../components/MobileMenu'
import { AuthContext } from '../../contexts/AuthContext'
import { withTranslation } from 'react-i18next'
import './style.css'

class Header extends Component {
    static contextType = AuthContext;

    state = {
        isSearchShow: false,
        showUserMenu: false,
    }

    searchHandler = () => {
        this.setState({
            isSearchShow: !this.state.isSearchShow
        })
    }

    toggleUserMenu = () => {
        this.setState({
            showUserMenu: !this.state.showUserMenu
        })
    }

    closeUserMenu = () => {
        this.setState({
            showUserMenu: false
        })
    }

    handleLogout = async () => {
        this.closeUserMenu();
        const { logout } = this.context;
        if (logout) {
            await logout();
            window.location.href = '/';
        }
    }

    scrollToSection = (sectionId) => (e) => {
        e.preventDefault();
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    render() {
        const { isSearchShow, showUserMenu } = this.state;
        const { user, isAuthenticated } = this.context || {};
        const { t } = this.props; // Translation function

        const ClickHandler = () => {
            window.scrollTo(10, 0);
        }

        return (
            <header id="header" className={this.props.topbarNone}>
                <div className={`wpo-site-header ${this.props.hclass}`}>
                    <nav className="navigation navbar navbar-expand-lg navbar-light">
                        <div className="container-fluid">
                            <div className="row align-items-center">
                                <div className="col-lg-3 col-md-3 col-3 d-lg-none dl-block">
                                    <div className="mobail-menu">
                                        <MobileMenu />
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6 col-6">
                                    <div className="navbar-header">
                                        <Link onClick={ClickHandler} className="navbar-brand" to="/home"><img src={this.props.Logo}
                                            alt="" loading="lazy" decoding="async" /></Link>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-1 col-1">
                                    <div id="navbar" className="collapse navbar-collapse navigation-holder">
                                        <button className="menu-close"><i className="ti-close"></i></button>
                                        <ul className="nav navbar-nav mb-2 mb-lg-0">
                                            <li>
                                                <Link onClick={ClickHandler} to="/">{t('home')}</Link>
                                            </li>
                                            <li>
                                                <a href="#about" onClick={this.scrollToSection('about')}>{t('aboutNav')}</a>
                                            </li>
                                            <li>
                                                <a href="#features" onClick={this.scrollToSection('features')}>{t('featuresNav')}</a>
                                            </li>
                                            <li>
                                                <a href="#level-test" onClick={this.scrollToSection('level-test')}>{t('assessment')}</a>
                                            </li>
                                            <li>
                                                <a href="#contact" onClick={this.scrollToSection('contact')}>{t('contact')}</a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-2 col-2">
                                    <div className="header-right">
                                        {isAuthenticated && user ? (
                                            <div className="header-user-menu">
                                                <div className="user-menu-container">
                                                    <button
                                                        className="user-menu-trigger"
                                                        onClick={this.toggleUserMenu}
                                                        aria-label={t('userMenu')}
                                                    >
                                                        {user?.profile_picture ? (
                                                            <img
                                                                src={user.profile_picture}
                                                                alt={user.first_name}
                                                                className="user-avatar"
                                                            />
                                                        ) : (
                                                            <div className="user-avatar-placeholder">
                                                                {user?.first_name?.[0]}{user?.last_name?.[0]}
                                                            </div>
                                                        )}
                                                        <div className="user-info">
                                                            <span className="user-name">
                                                                {user?.first_name} {user?.last_name}
                                                            </span>
                                                            <span className="user-email">{user?.email}</span>
                                                        </div>
                                                        <i className={`ti-angle-${showUserMenu ? 'up' : 'down'} dropdown-arrow`}></i>
                                                    </button>

                                                    {showUserMenu && (
                                                        <>
                                                            <div className="user-menu-backdrop" onClick={this.closeUserMenu}></div>
                                                            <div className="user-menu-dropdown">
                                                                <div className="dropdown-header">
                                                                    <div className="dropdown-user-info">
                                                                        {user?.profile_picture ? (
                                                                            <img
                                                                                src={user.profile_picture}
                                                                                alt={user.first_name}
                                                                                className="dropdown-avatar"
                                                                            />
                                                                        ) : (
                                                                            <div className="dropdown-avatar-placeholder">
                                                                                {user?.first_name?.[0]}{user?.last_name?.[0]}
                                                                            </div>
                                                                        )}
                                                                        <div className="dropdown-user-details">
                                                                            <h4>{user?.first_name} {user?.last_name}</h4>
                                                                            <p>{user?.email}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div className="dropdown-content">
                                                                    <Link to="/dashboard" onClick={this.closeUserMenu} className="dropdown-item">
                                                                        <i className="ti-dashboard"></i>
                                                                        <span>{t('dashboard')}</span>
                                                                    </Link>
                                                                    <Link to="/profile" onClick={this.closeUserMenu} className="dropdown-item">
                                                                        <i className="ti-user"></i>
                                                                        <span>{t('profile')}</span>
                                                                    </Link>
                                                                    <Link to="/subscription" onClick={this.closeUserMenu} className="dropdown-item">
                                                                        <i className="ti-credit-card"></i>
                                                                        <span>{t('subscription')}</span>
                                                                    </Link>

                                                                    <div className="dropdown-divider"></div>

                                                                    <button onClick={this.handleLogout} className="dropdown-item logout-item">
                                                                        <i className="ti-power-off"></i>
                                                                        <span>{t('logout')}</span>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="header-auth-buttons">
                                                <div className="auth-buttons">
                                                    <Link to="/login" className="btn btn-outline-primary">{t('login')}</Link>
                                                    <Link to="/signup" className="btn btn-primary">{t('signupNav')}</Link>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </nav>
                </div>
            </header>
        )
    }
}

export default withTranslation()(Header)